import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import displayError from '../../utilities/displayError';

const TextField = ({
  className = '',
  inputClassName = '',
  input = {},
  meta = {},
  placeholder = null,
  errorMessage = null,
  attributes = {},
  preInputElements = null,
  postInputElements = null,
  isError = false
}) => {
  const { error, submitFailed } = meta;
  const textFieldClassNames = classNames('TextField', className);
  const showError = isError || (error && submitFailed);
  const inputGroup = classNames({ 'input-group': preInputElements || postInputElements });

  return (
    <div className={textFieldClassNames}>
      <div className={inputGroup}>
        { preInputElements }
        <input
          {...input}
          type="text"
          placeholder={placeholder}
          className={classNames('form-control', inputClassName, { error: showError })}
          maxLength="50"
          {...attributes}
        />
        { postInputElements }
      </div>
      {
        (showError) && (
          <p className="error text-danger text-small">
            {displayError(errorMessage, error)}
          </p>
        )
      }
    </div>
  );
};

TextField.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object,
  placeholder: PropTypes.string,
  errorMessage: PropTypes.string,
  attributes: PropTypes.object,
  preInputElements: PropTypes.element,
  postInputElements: PropTypes.element,
  isError: PropTypes.bool
};

export default TextField;
